import styled from "styled-components";

export const HeaderContainer = styled.header`
  width: 100%;
  background-color: #f3e5f5;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  padding: 10px;
`;

export const Title = styled.h1`
  margin: 0;
  color: #9c27b0;
  padding: 0;
`;
